module.exports = __webpack_public_path__ + "img/about-ch2-problems-inclusivity.453516bc.png";